var React = require('react');

function Cases1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43.5806 33.7857H5.93211C3.13725 33.7857 1 31.3046 1 28.4691V6.3166C1 3.30386 3.30165 1 5.93211 1H43.4162C46.211 1 48.3483 3.48108 48.3483 6.3166V28.4691C48.5127 31.4819 46.3754 33.7857 43.5806 33.7857Z","fill":"#E0D6FF","stroke":"#5A32CA","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1.32812 11.043H47.441","stroke":"#5A32CA","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.375 28.3214H17.073","stroke":"#5A32CA","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Cases1.defaultProps = {"width":"50","height":"35","viewBox":"0 0 50 35","fill":"none"};

module.exports = Cases1;

Cases1.default = Cases1;
